import { v4, replace, resolvePromiseWithDelay } from "@smart/itops-utils-basic";

import {
  getLocalSmokeballAppContext,
  setLocalSmokeballAppContext,
} from "./utils";
import {
  AddRelationshipRequest,
  LocalSmokeballAppContext,
  Relationship,
  Relationships,
  UpdateRelationshipRequest,
} from "../types";

export const useRelationships = () => ({
  get: (roleId: string) => {
    const roleRelationships =
      getLocalSmokeballAppContext()?.relationships?.find(
        (rr) => rr.roleId === roleId,
      );

    return resolvePromiseWithDelay(
      (roleRelationships?.relationships || {
        relationships: [],
        versionId: v4(),
      }) as Relationships,
    );
  },
  add: ({ roleId, contactId, name }: AddRelationshipRequest) => {
    const localContext = getLocalSmokeballAppContext();
    const existing = localContext?.relationships.find(
      (r) => r.roleId === roleId,
    );
    const addedRelationship: Relationship = {
      id: v4(),
      contactId,
      name,
      representativeIds: [],
    };

    if (existing) {
      existing.relationships = [...existing.relationships, addedRelationship];
    } else {
      const updatedContext = {
        ...localContext,
        relationships: [
          ...(localContext?.relationships || []),
          { roleId, relationships: [addedRelationship] },
        ],
      } as LocalSmokeballAppContext;
      setLocalSmokeballAppContext(updatedContext);
    }

    return resolvePromiseWithDelay(addedRelationship);
  },
  update: ({ roleId, contactId, id }: UpdateRelationshipRequest) => {
    const localContext = getLocalSmokeballAppContext();
    const updateRoleRelationship = localContext?.relationships.find(
      (r) => r.roleId === roleId,
    );
    if (!updateRoleRelationship) {
      throw new Error(`Role ${roleId} not found.`);
    }

    const existingRelationship = updateRoleRelationship.relationships.find(
      (rel) => rel.id === id,
    );
    if (!existingRelationship) {
      throw new Error(`Relationship ${id} for role ${roleId} not found.`);
    }

    const updateRelationship = { ...existingRelationship, contactId };

    updateRoleRelationship.relationships = replace(
      updateRoleRelationship.relationships,
      (r) => r.id === id,
      updateRelationship,
    );

    const updatedContext = {
      ...localContext,
      relationships:
        localContext?.relationships &&
        replace(
          localContext.relationships,
          (r) => r.roleId === roleId,
          updateRoleRelationship,
        ),
    } as LocalSmokeballAppContext;
    setLocalSmokeballAppContext(updatedContext);

    return resolvePromiseWithDelay(updateRelationship);
  },
});
